module.exports = __webpack_public_path__ + "static/media/save.53634b8d.svg";